module.exports = __webpack_public_path__ + "8ecd2a416b0d8b5843c8efa27bae6c61.svg";